import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  en: {
    welcome: 'Welcome',
    greeting: 'Hello, {name}!',
  },
  zh: {
    welcome: '欢迎',
    greeting: '你好, {name}!',
  },
};

const i18n = new VueI18n({
  locale: 'en', // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages, // 语言包
});

export default i18n;